import Image from "next/image"
import Link from "next/link"
import Cookies from 'js-cookie';
import logo from '@/assets/images/logo.png'
import SkeletonLoader from "@/Layout/SkeletonLoader"
import { RiLogoutBoxLine } from "react-icons/ri";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { GlobeIconSVG } from "../Common/SVGs/CommonSVG";
import LanguageDropdown from "../Common/LanguageDropdown";

const AuthTop = (props) => {
    const { title, roleFromUrl, skeletonLoading, logoutBtn = true, translations } = props;
    
    const router = useRouter();
    const hasCookies = Cookies.get('iat') || Cookies.get('bat') || Cookies.get('verifyUAT');

    const logout = () => {
        Cookies.remove('aat');
        Cookies.remove('iat');
        Cookies.remove('bat');
        Cookies.remove('verifyUAT');
        Cookies.remove('user_info')
        Cookies.remove('cc_auth')
        Cookies.remove('campaign_slug');
        Cookies.remove('register_email');
        Cookies.remove('admin_email');
        Cookies.remove('forgot_email');
        sessionStorage.clear();
        window.location.href = '/login';
    }

    return (
        <div className="flex items-center justify-between md:mb-20 sm:mb-10 mb-6">
            {skeletonLoading ? <SkeletonLoader width="182" height={28} rows={1} /> :
                <Link href="/">
                    <Image src={logo} alt='Logo' className="max-sm:w-32 sm:h-10 w-auto" />
                </Link>
            }
            <div className="flex items-center gap-2">
                <LanguageDropdown />
                {roleFromUrl == undefined ? null :
                    skeletonLoading ? <SkeletonLoader width="182" height={28} rows={1} /> : <span className="text-xs xs:text-sm">{title}</span>
                }
                {(hasCookies && logoutBtn) && <span className="flex items-center gap-1.5 cursor-pointer text-sm" onClick={logout}><RiLogoutBoxLine size={20} /> {translations?.logOut}</span>}
            </div>
        </div>
    )
}

export default AuthTop
